// extracted by mini-css-extract-plugin
export default {"link":"UA-z","disabled":"VA-z"};